module.exports = __webpack_public_path__ + "img/heart.4840f6dd.svg";